module.exports = __webpack_public_path__ + "nodejs.png?420026d2bfd12297a9c8f748328aa882";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodejs.png
// module id = 11
// module chunks = 0